import React from 'react'
import { Typography } from 'antd'

interface BProps {
  children?: any
  data?: string
  title: string
  small?: boolean
  strong?: boolean
}

const s = {
  brick: { fontSize: 14, marginBottom: 0, fontWeight: 500, color: '#262626' },
  value: { fontSize: 16, fontWeight: 600, color: '#262626' },
}
const { Text } = Typography

const Brick: React.FC<BProps> = ({ title, data, children, strong }) => (
  <div style={{ margin: '16px 0px', flex: 1 }}>
    <Text style={s.brick}>{title}</Text>
    <div>
      <Text strong={strong} style={s.value}>
        {data}
      </Text>
    </div>
    {children}
  </div>
)

export default Brick
